import React from 'react';
import { FiTrendingUp, FiTrendingDown } from 'react-icons/fi';
import { breadthText, formatListMove } from '../utils/listMovers';

/**
 * Desktop rendering of today's leading / lagging smart lists (issue #341) for the Market
 * Analysis "Smart Lists" card. `movers` comes from `rankListMovers` — the SAME ranking the mobile
 * Brief's cards are built on — so this component only draws; it never decides who ranks.
 *
 * Collapsed: one line per side in the Sectors card's idiom ("↑ Nuclear Power +2.7%, …").
 * Expanded: a row per list with its breadth, each a button that opens the list in the table.
 */

const SIDES = [
  { key: 'leaders', label: 'Leading', icon: FiTrendingUp, modifier: 'up' },
  { key: 'laggards', label: 'Lagging', icon: FiTrendingDown, modifier: 'down' },
];

// Each name is a link that opens the list directly; stopPropagation keeps the click from
// also toggling the card, whose whole header is the expand control.
const openList = (onSelectList, id) => (event) => {
  event.stopPropagation();
  onSelectList?.(id);
};

export const ListMoversSummary = ({ movers, onSelectList }) => (
  <div className="sectors-summary">
    <div className="sectors-summary__items">
      {SIDES.map(({ key, icon: Icon, modifier }) => movers[key].length > 0 && (
        <span key={key} className={`sectors-summary__item sectors-summary__item--${modifier}`}>
          <Icon />
          {movers[key].map((e, i) => (
            <React.Fragment key={e.id}>
              {i > 0 && ', '}
              <button type="button" className="list-movers__link" onClick={openList(onSelectList, e.id)}>
                {e.name} {formatListMove(e.avgChange)}
              </button>
            </React.Fragment>
          ))}
        </span>
      ))}
    </div>
  </div>
);

export const ListMoversDetail = ({ movers, onSelectList }) => (
  <div className="list-movers">
    {SIDES.map(({ key, label, icon: Icon, modifier }) => movers[key].length > 0 && (
      <div key={key} className="list-movers__side">
        <div className={`list-movers__heading sectors-summary__item--${modifier}`}>
          <Icon /> {label} today
        </div>
        {movers[key].map((entry) => (
          <button
            key={entry.id}
            type="button"
            className="list-movers__row"
            onClick={openList(onSelectList, entry.id)}
            title={`${breadthText(entry)} of ${entry.stocksWithData} stocks · open list`}
          >
            <span className="list-movers__name">{entry.name}</span>
            <span className="list-movers__breadth">{breadthText(entry)}</span>
            <span className={`list-movers__change sectors-summary__item--${modifier}`}>
              {formatListMove(entry.avgChange)}
            </span>
          </button>
        ))}
      </div>
    ))}
    <div className="list-movers__note">
      Average move of each list's members today. Lists defined by the day's move are left out,
      and a list ranks only when at least 60% of its members move the same way.
    </div>
  </div>
);
